export default __webpack_public_path__ + "static/media/gallery_23.3cf271df.jpg";